<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        md4
        v-for="(event, index) of activeEvents"
        :key="`activeEvent${index}`"
      >
        <active-event :event-id="event._id" />
      </v-flex>
      <v-flex>
        <v-alert
          :value="true"
          color="white"
          class="grey--text"
          icon="info"
          v-if="!activeEvents.length"
        >
          אין אירועים פעילים
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ActiveEvent from "./active/ActiveEvent.vue";

export default {
  data: () => ({
    newEventDialog: false
  }),

  computed: {
    activeEvents() {
      return this.$store.getters["events/activeEvents"];
    }
  },

  methods: {},

  components: {
    ActiveEvent
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/ActiveEvents.vue